import { SeriesIndexEvent } from '../../../store/series/types';

// "Current" event = the latest event on the timeline. The index `events[]`
// array is dateTime-ascending (booking-service `findAllBySeriesId` sorts on
// the webhooks path; the backfill mirrors that sort), so it's just the last
// element.
export function findCurrentIndexEvent(events: SeriesIndexEvent[]): SeriesIndexEvent | null {
  if (events.length === 0) {
    return null;
  }
  return events[events.length - 1];
}
